import { Link, useTheme } from "@mui/material";
import { getDomain } from "tldts";
import { usePublisherSearch } from "../hooks/publisher-search.hook";
import { logEvent } from "services/amplitude.service";
import { useDispatch } from "react-redux";
import { setBoclipsPopup, setBoclipsVideoId } from "context/features/dataSlice";
import useLocalStorage from "@rehooks/local-storage";
import { useSelector } from "react-redux";
import { murmurhash3_32_gc } from "utils/string.util";
import { useTrackedArticles } from "../hooks";

const AFP_PATH = "/afp-article/";

export default function SearchResultLink({
  url,
  trackingCat,
  trackingOptions,
  children,
  sx,
  ...props
}) {
  const { palette } = useTheme();
  const dispatch = useDispatch();
  const { getPublisherToken } = usePublisherSearch();

  const {addClickedLink, hasBeenClicked} = useTrackedArticles(url);

  async function handleClick(event) {
    event.preventDefault();
    const url = event.target.href;
    if(!hasBeenClicked) {
      addClickedLink(url);
    }
    let newUrl = url;
    switch (getDomain(url).toLocaleLowerCase()) {
      case "economist.com":
      case "washingtonpost.com":
        try {
          newUrl = await getPublisherToken(url);
        } catch {}
        break;
      case "foreignpolicy.com":
        newUrl += "?auth=sooth";
        break;
      case "boclips.com":
        dispatch(setBoclipsVideoId(url.split("/").pop()));
        dispatch(setBoclipsPopup(true));
        return false;
      default:
        if (url.includes(AFP_PATH)) {
          newUrl = `${window.location.origin}${AFP_PATH}${url
            .split("/")
            .pop()}`;
        }
        break;
    }
    window.open(newUrl, "_blank");

    if (trackingCat != null && trackingOptions != null) {
      logEvent(trackingCat, trackingOptions);
    }
    return false;
  }
  return (
    <Link
      href={url}
      target="_blank"
      onClick={handleClick}
      sx={{
        color: palette.text.primary,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Link>
  );
}
